export let webUrl = "";
const test_host = "hissct.mobimedical.cn";
const _host = window.location.host;

if (
  _host == test_host ||
  _host.includes("localhost:") ||
  _host == "hlwyy.gyjkk.cn"
) {
  //测试环境
  webUrl = "https://hlwyy.gyjkk.cn/";
} else {
  //正式环境
  webUrl = "https://hlwyy.gyjkk.cn/";
}

export let healthCardItems = sessionStorage.getItem("healthCardItems")
  ? JSON.parse(sessionStorage.getItem("healthCardItems"))
  : undefined;

export function getQueryString(name, url = null) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = "";
  if (url) {
    r = url.split("?")[1].match(reg);
  } else {
    r = window.location.search.substr(1).match(reg);
  }

  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

export default { webUrl, healthCardItems, getQueryString };



// WEBPACK FOOTER //
// ./src/views/general-hospital/utils/utils.js